import { render, staticRenderFns } from "./InfoTablaFoto.vue?vue&type=template&id=54f4c38f&"
import script from "./InfoTablaFoto.vue?vue&type=script&lang=js&"
export * from "./InfoTablaFoto.vue?vue&type=script&lang=js&"
import style0 from "./InfoTablaFoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VImg,VLayout,VProgressCircular,VRow})
